import { supabase } from '../lib/supabaseClient';
 
// Returns the active survey question if one exists AND the user hasn't
// answered it yet AND it's past 8am local time. Otherwise returns null.
// This is the single source of truth the bell/dropdown reads from —
// no separate "notification" row to keep in sync.
export async function getActiveSurveyNotification(userId) {
  const localHour = new Date().getHours();
  if (localHour < 8) return null; // too early local time, don't surface it
 
  const { data: question, error: qError } = await supabase
    .from('survey_questions')
    .select('id, question_text')
    .eq('status', 'live')
    .maybeSingle();
 
  if (qError || !question) return null;
 
  const { data: options, error: oError } = await supabase
    .from('survey_answer_options')
    .select('id, label')
    .eq('question_id', question.id)
    .order('sort_order', { ascending: true });
 
  if (oError || !options || options.length === 0) return null;
 
  question.options = options; // [{ id, label }, ...] — same shape SurveyModal expects
 
  const { data: myResponse } = await supabase
    .from('survey_responses')
    .select('id')
    .eq('question_id', question.id)
    .eq('user_id', userId)
    .maybeSingle();
 
  if (myResponse) return null; // already answered — nothing to show
 
  return { type: 'survey', question };
}
 
// Submits a response. response_feedback is static for now; future quippy
// replies can populate this same column (or a joined table) with no
// migration needed.
export async function submitSurveyResponse(questionId, userId, answerOptionId) {
  const { error } = await supabase.from('survey_responses').insert({
    question_id: questionId,
    user_id: userId,
    answer_option_id: answerOptionId,
    response_feedback: 'Thanks for your response!',
  });
  return { error };
}
 

